import { render, staticRenderFns } from "./UpcomingDomainCrawlsWidget.vue?vue&type=template&id=d3b89d94&"
import script from "./UpcomingDomainCrawlsWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingDomainCrawlsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports